<template>
  <div class="block-item-container">
    <div class="block-item-title-content flex justify-between items-center">
      <div class="title">订单详情</div>
    </div>
    <div class="flex flex-col info-list">
      <div class="flex items-center info-item">
        <span class="name">产品名称：</span>
        <span class="desc">{{ detail.display_plan }}</span>
      </div>
      <div class="flex items-center info-item">
        <span class="name">简历语言：</span>
        <span class="desc">{{ detail.cv_lang_desc }}</span>
      </div>
      <div class="flex items-center info-item">
        <span class="name">目标行业领域：</span>
        <span class="desc">{{ detail.industry_desc }}</span>
      </div>
      <div class="flex items-center info-item">
        <span class="name">是否转行：</span>
        <span class="desc">{{ detail.change_profession | formatChangeProfession }}</span>
      </div>
      <div class="flex items-center info-item">
        <span class="name">加急选项：</span>
        <span class="desc">{{ detail.urgency_desc }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderDetail",
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  filters: {
    formatChangeProfession(value) {
      return value ? "是" : "否";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";

.info-list {
  gap: 12px;
  .info-item {
    .name {
      color: $mentor-order-title;
    }
    .desc {
      color: $mentor-order-desc;
    }
  }
}
</style>
